import React from "react";
import { Grid, Progress, Segment } from "semantic-ui-react";
import {
  getNumberWithCommas,
  getPercentage,
  getProgressDisplayType
} from "../../../../utils/utils";
import { ProgressDisplayStatus } from "./types";

type DatabaseUsageProgressBarProps = {
  /** Database total size.*/
  databaseSize: number;
  /** Database usage.*/
  databaseUsage: number;
};

type DatabaseUsageProgressBarState = {
  progressDisplayTypeStatues: ProgressDisplayStatus;
  percentage: number;
};

class DatabaseUsageProgressBar extends React.PureComponent<
  DatabaseUsageProgressBarProps,
  DatabaseUsageProgressBarState
> {
  constructor(props: DatabaseUsageProgressBarProps) {
    super(props);
    const percentage = getPercentage(props.databaseUsage, props.databaseSize);
    this.state = {
      progressDisplayTypeStatues: getProgressDisplayType(percentage),
      percentage: percentage
    };
  }

  render = () => (
    <Segment>
      <Grid textAlign="center" style={{ height: "100%" }} verticalAlign="top">
        <Grid.Row columns={1} style={{ paddingBottom: 0 }}>
          <Grid.Column>
            <Progress
              progress="percent"
              percent={this.state.percentage}
              success={this.state.progressDisplayTypeStatues["success"]}
              warning={this.state.progressDisplayTypeStatues["warning"]}
              error={this.state.progressDisplayTypeStatues["error"]}
              style={{ margin: 0 }}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={2} style={{ paddingTop: "1px", paddingBottom: "9px" }}>
          <Grid.Column width={8} textAlign="left">
            <strong>Database size</strong>
          </Grid.Column>
          <Grid.Column width={8} textAlign="right">
            <span color="grey">
              {getNumberWithCommas(this.props.databaseUsage)} of{" "}
              {getNumberWithCommas(this.props.databaseSize)} MB
            </span>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
}

export default DatabaseUsageProgressBar;
